<h1 mat-dialog-title>Payment Information for <strong>Property Id:</strong> {{ data.property_id }}</h1>
<div mat-dialog-content>
    <!-- <div class="row justify-content-center mt-2" *ngIf="selectedPayment">
        <strong class="mr-2 label">Payment Method</strong>
        <div class="form-group">
            <select class="form-control" [(ngModel)]="selectedPayment">
                <option *ngFor="let type of paymentMethods" [value]="type.value">{{ type.value }}</option>
            </select>
        </div>
    </div>
    <mat-divider class="mt-4 mb-4"></mat-divider> -->
    <div class="row" *ngIf="selectedPayment == 'Bank Payment'">
        <form class="col-sm-12 row m-auto" [formGroup]="basicInfoForm">
            <div class="col-sm-12 image-holder">
                <img *ngIf="!imgURL" src="assets/placeholder-image.png" />
                <img *ngIf="imgURL" [src]="imgURL" />
                <div class="file-chooser">
                  <p class="text-center">Select Voucher Image</p>
                  <input (change)="fileChangeEvent($event)" type="file">
                </div>
            </div>
            <div class="col-sm-12 form-group">
                <label for="remarks">
                    Remarks
                </label>
                <textarea class="form-control" formControlName="remarks" id="remarks" value="remarks"></textarea>  
            </div>
        </form>
    </div>
    <div class="row m-2" *ngIf="selectedPayment == 'Transferred to Bank'">
        <form class="col-sm-12 row" [formGroup]="transactionForm">
            <div class="col-sm-12 image-holder">
                <img *ngIf="!imgURL" src="assets/placeholder-image.png" />
                <img *ngIf="imgURL" [src]="imgURL" />
                <div class="file-chooser">
                  <p class="text-center">Select Voucher Image</p>
                  <input (change)="fileChangeEvent1($event)" type="file">
                </div>
            </div>
            <div class="col-sm-12 col-md-6 form-group">
                <label for="payment">
                    Payment Method
                </label>
                <input class="form-control" formControlName="paymentMethod" id="payment">
            </div>
            <div class="col-sm-12 col-md-6 form-group">
                <label for="transaction">
                    Reference Code
                </label>
                <input class="form-control" formControlName="transaction_id" id="transaction">
            </div>
        </form>
    </div>
    <div class="row m-2" *ngIf="selectedPayment == 'esewa' || selectedPayment == 'Pay In Cash'">
        <form class="col-sm-12 row" [formGroup]="transactionForm">
            <div class="col-sm-12 image-holder" *ngIf="selectedPayment == 'esewa' ">
                <img *ngIf="!imgURL" src="assets/placeholder-image.png" />
                <img *ngIf="imgURL" [src]="imgURL" />
                <div class="file-chooser">
                  <p class="text-center">Select Voucher Image</p>
                  <input (change)="fileChangeEvent1($event)" type="file">
                </div>
            </div>
            <div class="col-sm-12 col-md-12 form-group">
                <label for="transaction">
                    Reference Code
                </label>
                <input class="form-control" formControlName="transaction_id" id="transaction">
            </div>
        </form>
    </div>
</div>
<div mat-dialog-actions class="row col-sm-12 justify-content-end">
  <button mat-button mat-dialog-close>Close</button>
  <button mat-button (click)="saveTransactionInfo()" cdkFocusInitial>Save</button>
</div>